module.exports = __webpack_public_path__ + "img/UVM-LOGO_black-Copy.fa102ba3.png";